export default __webpack_public_path__ + "static/media/3.4d201b83.png";